import type { Theme } from '@mui/material';

function getSearchInputCss() {
	return {
		'&:before, &:after': {
			border: 'none !important',
		},
	};
}

export const muiInputBaseOverrides = {
	defaultProps: {
		autoComplete: 'off',
	},
	styleOverrides: {
		root: ({ theme }: { ownerState; theme: Theme }) => ({
			boxSizing: 'content-box !important',
			width: '100%',
			fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
			color: theme.palette.tsGoColor.black,
			variants: [
				{
					props: {
						'ts-variant': 'searchTeamNameInput',
					},
					style: getSearchInputCss(),
				},
			],
		}),
	},
};
